import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { publicAuthRoutes } from 'app/modules/auth/public-auth.routes';
import { OverviewComponent } from 'app/modules/overview/overview.component';
import { VenuesComponent } from 'app/modules/venues/venues.component';
import { CourtsComponent } from 'app/modules/courts/courts.component';
import { BookingsComponent } from 'app/modules/bookings/bookings.component';
import { ReportComponent } from './modules/report/report.component';
import { BookingComponent } from './modules/bookings/booking/booking.component';
import { AuditReportComponent } from './modules/report/audit-report/audit-report.component';
import { PolicyComponent } from './modules/policy/policy.component';
import { AccountDeletionComponent } from './modules/policy/account-deletion/account-deletion.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'example' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: '', pathMatch: 'full', redirectTo: 'overview' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: publicAuthRoutes
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes') }
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },

            { path: 'dashboard', loadChildren: () => import('app/modules/landing/home/home.routes') },

            { path: 'policy', component: PolicyComponent },
            { path: 'account-deletion', component: AccountDeletionComponent }

        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'overview', component: OverviewComponent },
            { path: 'players-overview', loadComponent: () => import('app/modules/players-overview/players-overview.component').then(component => component.PlayersOverviewComponent) },
            { path: 'players', loadComponent: () => import('app/modules/players-overview/venue-players.component').then(component => component.VenuePlayersComponent) },
            { path: 'venues', component: VenuesComponent },
            { path: 'venue/:id', component: CourtsComponent },
            { path: 'bookings', component: BookingsComponent },
            { path: 'booking', component: BookingComponent },
            { path: 'settings', loadChildren: () => import('app/modules/admin/settings/settings.routes') },
            { path: 'reports', component:ReportComponent},
            { path: 'audit-reports', component:AuditReportComponent},
        ]
    }
];
